import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PipesModule } from './shared/pipes/pipes.module';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { environment } from 'src/environments/environment';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { NotFoundComponent } from './modules/layout/not-found/not-found.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreService } from './services/core.service';
import { BreadcrumbService } from './providers/services/breadcrumb.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ModalSendApproveComponent } from './shared/modal-send-approve/modal-send-approve.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LoadingInterceptor } from './util/loading.interceptor';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonsModule } from 'octang';
import { ModalVehicleRestrictionsComponent } from './shared/modal-vehicle-restrictions/modal-vehicle-restrictions.component';
import { NoCache } from './util/cache.interceptor';
import { WidthViewComponent } from './modules/width-view/width-view.component';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AngularFireModule } from '@angular/fire/compat';
//import { ScreenTrackingService, UserTrackingService } from '@angular/fire/compat/analytics';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

registerLocaleData(localePt);

@NgModule({ declarations: [
        AppComponent,
        NotFoundComponent,
        ModalSendApproveComponent,
        SpinnerComponent,
        ModalVehicleRestrictionsComponent,
        WidthViewComponent,
    ],
    bootstrap: [AppComponent], imports: [
        //NgxGoogleAnalyticsModule.forRoot(environment.googleAnalicts.measurementId),
        AngularFireModule.initializeApp(environment.firebase),
        AngularSvgIconModule.forRoot(),
        //NgxGoogleAnalyticsRouterModule,
        BrowserModule,
        AppRoutingModule,
        ConfirmDialogModule,
        BrowserAnimationsModule,
        ToastModule,
        RouterModule,
        PipesModule,
        MessagesModule,
        MessageModule,
        NgxCaptchaModule,
        TooltipModule,
        ButtonsModule], providers: [
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: NoCache, multi: true },
        MessageService,
        ConfirmationService,
        CoreService,
        BreadcrumbService,
        // ScreenTrackingService,
        // UserTrackingService,
        provideEnvironmentNgxMask(),
        NgxImageCompressService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
